import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common/index.js'
import user from './modules/user/index.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common: common,
    user: user
  }
  , 
  state: {  
    // 在这里定义你的数据  
    // targetpath:'http://admin.87gao.cn/dev-api',
    targetpath:'http://admin.qxwyhospital.cn/dev-api',
  },  
  /* state,
  actions,
  mutations */
})



// WEBPACK FOOTER //
// ./src/store/index.js